import React from 'react';
import './style.css'
import QRCode from "react-qr-code";
import { useSelector } from 'react-redux';
import { store } from '../../../redux/store';
import { setGoHome } from '../../../redux/slices/initLoad/types';
import ChangeLang from '../../../components/changeLang';

const FOOTER_WOOD_BG = require('./assets/tabla.png');
const BACKGROUND_VIDEO = require('./assets/bk.mp4');

const Index = ({ showBack = true, showFlame=true,showCocktails = false,showEvents = false,showImageTop = true, showLamp = true,children, showLogo=true, showFooter=true, setShowListProduct, setShowSpecials, goHome, goCategories }) => {
   
  const [showModal, setShowModal] = React.useState(false);
  const [showBoost, setshowBoost] = React.useState(false);
  const [showModalPincode, setShowModalPincode] = React.useState(false);
  const [secret, setScret] = React.useState("");

  const handleButtonClick = () => {
    if (setShowListProduct) {
      setShowListProduct(false); 
    }
  };
  


   const {
      goHomeInit
   } = useSelector((state) => state.initLoad);


  const validScret = () => {

    if (secret === '') {
      alert('Debe ingresar el pin')
    }

    if (secret === "2355") {
       window.location.reload();
    } else {
       alert('Code invalid')
    }
    
  }
  
    return (
      <div className='backgroundlayout' style={{
        flex: 1,
        backgroundSize: 'cover',
        width: '100%',
        height: '100vh',
        position: 'relative',
        overflow: 'hidden'
      }}>

        <video
          autoPlay
          loop
          muted
          playsInline
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            zIndex: 0
          }}
        >
          <source src={BACKGROUND_VIDEO} type="video/mp4" />
        </video>

        <div style={{ position: 'relative', zIndex: 1, height: '100%' }}>
          {/*<button onClick={()=>setOpenNav(!openNav)} style={{...styles.iconMenuMobile, ...iconMenu}}>
            <Menu />
          </button>*/}
          

          <div className='contentChild' >
               

            <div className='nav-menu-bar' style={{
              marginTop:  0,
              width: '100%',
              position: 'relative'
            
            }}>

             
              {showLogo &&
              <div style={{
               
                paddingTop: 20,
                paddingBottom: 20,
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: showBack ? 'space-between':'center',
            
                }}>
                  
                  <div style={{ display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',}}>
                     {showBack && (
                        <div
                            onClick={()=>handleButtonClick()}
                                style={{
                                  width: 150,
                                  height: 52,
                                  display: 'flex',
                                  textAlign: 'center',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  gap: 8,
                                  cursor: 'pointer',
                                  marginLeft: 15,
                                  zIndex: 999,
                                  position: 'relative',
                                  borderRadius: 12,
                                  border: '2px solid rgba(83, 45, 16, 0.95)',
                                  background: 'linear-gradient(180deg, #d29b5f 0%, #a76735 52%, #7d4520 100%)',
                                  boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.35), inset 0px 1px 0px rgba(255, 255, 255, 0.35)',
                                  userSelect: 'none'
                            }}>
                            <span
                              style={{
                                color: '#ffd26a',
                                fontFamily: 'Galantic, Impact, Arial Black, Arial, sans-serif',
                                fontSize: 20,
                                lineHeight: 1,
                                textShadow: '0px 2px 0px rgba(70, 35, 12, 0.95)'
                              }}
                            >
                              {"<"}
                            </span>
                            <p
                              style={{
                                color: '#ffd26a',
                                fontFamily: 'Galantic, Impact, Arial Black, Arial, sans-serif',
                                fontSize: 18,
                                letterSpacing: 1,
                                textTransform: 'uppercase',
                                margin: 0,
                                textShadow: '0px 2px 0px rgba(70, 35, 12, 0.95), 0px 4px 6px rgba(0, 0, 0, 0.35)'
                              }}
                            >
                              Back
                            </p>
                          </div>
                    )}

                  </div>
                  
                  <div style={{
                      alignItems: 'center',}}   >
                       <div style={{
                      
                        display: 'flex',
                          alignItems: 'center',
                              position: 'relative',
                              zIndex: 999,
                              justifyContent: 'end',}}>
                        {/* <div onClick={()=>setShowModal('https://www.instagram.com/colombiansteakhouse/')} target='_blank'> <img
                        style={{
                          width: 28,
                            height: 28,
                            marginInline: 10
                        
                      }}
                      src={require('./assets/instagram.png')}
                      alt="Logo"
                      /> 
                      </div> */}

                      {/* <div target='_blank' onClick={()=>setShowModal('https://www.facebook.com/colombianNJ/photos')}> 
                        <img
                          style={{
                              width: 28,
                                height: 28,
                                marginInline: 10
                        }}
                          src={require('./assets/facebook.png')}
                          alt="Logo"
                        /> 
                      </div> */}

                  
                    <div>
                    {/* <ChangeLang /> */}
                    </div>
                      </div>
                  </div>

                 
              </div>
              }
              


            

            </div>
            {children}

            
            {showFooter &&
            <div
            style={{
              position: 'absolute',
              bottom: 0,
                  alignSelf: 'center',
                
                  width: '100%',
                  left: 0,
                  zIndex: 999
                
              
            }}>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
                marginTop: 5,
                width: '90%',
                backgroundImage: `url(${FOOTER_WOOD_BG})`,
                backgroundSize: '100% 100%',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                alignSelf: 'center',
                margin: '0 auto',
                borderRadius: 14,
                height: 70,
                boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.35)',
              }}>
              
              {/* HOME */}
              <div
                onClick={() => {
                  store.dispatch(setGoHome(Math.random()));
                }}
                style={{
                  flex: 1,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  cursor: 'pointer',
                  height: '100%'
                }}>
                <p style={{ color: '#ffc928', fontSize: 30,  fontFamily: 'Galantic', textTransform: 'uppercase', margin: 0, letterSpacing: 0.8, textShadow: '0px 2px 0px rgba(82, 45, 10, 0.95), 0px 4px 4px rgba(0, 0, 0, 0.35)' }}>HOME</p>
              </div>

              {/* DIVIDER */}
              <div style={{ width: 2, height: '70%', backgroundColor: 'rgba(255, 255, 255, 0.9)' }}></div>

              {/* BEVERAGES */}
              <div
                onClick={() => {
                  showCocktails(true)
                }}
                style={{
                  flex: 1,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  cursor: 'pointer',
                  height: '100%'
                }}>
                <p style={{ color: '#ffc928', fontSize: 30,  fontFamily: 'Galantic', textTransform: 'uppercase', margin: 0, letterSpacing: 0.8, textShadow: '0px 2px 0px rgba(82, 45, 10, 0.95), 0px 4px 4px rgba(0, 0, 0, 0.35)' }}>DRINKS</p>
              </div>

              {/* DIVIDER */}
              <div style={{ width: 2, height: '70%', backgroundColor: 'rgba(255, 255, 255, 0.9)' }}></div>

              {/* SPECIALS */}
              <div
                onClick={() => {
                  if (setShowSpecials) {
                    setShowSpecials(true)
                  }
                }}
                style={{
                  flex: 1,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  cursor: 'pointer',
                  height: '100%'
                }}>
                <p style={{ color: '#ffc928',fontSize: 30,  fontFamily: 'Galantic', textTransform: 'uppercase', margin: 0, letterSpacing: 0.8, textShadow: '0px 2px 0px rgba(82, 45, 10, 0.95), 0px 4px 4px rgba(0, 0, 0, 0.35)' }}>SPECIALS</p>
              </div>
            </div>
                




            <div
              style={{
                zIndex: 100,
                flexDirection: 'row',
                justifyContent: 'space-around',
                paddingHorizontal: 20,
                paddingVertical: 5,
                  alignItems: 'center',
                marginTop: 20,
              }}>
                  <div
                    onClick={()=> setshowBoost(true)}
                style={{flexDirection: 'row', alignItems: 'center'}}>
                <p
                  style={{
                      color: '#fff',
                      fontWeight: '300',
                      textAlign: 'center',
                      fontSize: 14,
                    }}>
                 Powered by boostyourmenu.com V1.6
                </p>
              </div>
            </div>
          </div>
            }
            
            {showBoost &&
              <div onClick={ ()=> setshowBoost(false)} style={{ position: 'absolute', top: 0, bottom: 0, left: 0, width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#00000063', zIndex: 9999, flexDirection: 'column' }}>
                <img
                 
                            style={{
                              width: 500,
                                height: 500,
                                marginInline: 10,
                                objectFit: 'contain',
                                zIndex: 9999
                            
                          }}
                          src={require('./assets/boost.png')}
                          alt="Logo"
                /> 
            
            </div>
            }
            

            {showModalPincode &&
              <div style={{ position: 'absolute', top: 0, bottom: 0, left: 0, width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#00000063', zIndex: 9999, flexDirection: 'column' }}>
                
                <div style={{ position: 'absolute',background: '#fff', width: 500, height: 300, borderRadius: 30, display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: "column" }}>
                  <img
                      onClick={()=>setShowModalPincode(false)}
                    style={{
                      position: 'absolute',
                      top: -10,
                      
                                width: 40,
                                  height: 40,
                                  marginInline: 10,
                                  objectFit: 'contain',
                                  position: 'absolute',
                                  right: -10,
                                  zIndex: 9999
                              
                            }}
                      src={require('./assets/close.png')}
                      alt="Logo"
                  /> 
                  <h4 style={{ color: '#F40000', fontSize: 40, fontWeight: 'bold', margin: 20 }}>PIN</h4>
                  <input type='number' style={{ width: 300, height: 40 }} onChange={(e) => {
                    setScret(e.target.value)
                  }} />
                  <br /><br />
                  
                  <div style={{display: 'flex', gap: 20}}>
                    <div onClick={() => setShowModalPincode(false)} style={{background: '#FF1616', width: 150, height: 50, justifyContent: 'center', alignItems: 'center', display: 'flex', borderRadius: 7}}>
                      <p style={{color: 'white', textTransform: 'uppercase', fontWeight: 'bold'}}>atras</p>
                    </div>
                    <div onClick={()=>validScret()} style={{ background: '#FF1616', width: 150, height: 50, justifyContent: 'center', alignItems: 'center', display: 'flex', borderRadius: 7 }}>
                      <p style={{color: 'white', textTransform: 'uppercase', fontWeight: 'bold'}}>Enviar</p>
                  </div>
                </div>
                </div>
              </div>
            }

            <img
                onClick={()=>setShowModalPincode(true)}
                        style={{
                          width: 40,
                            height: 40,
                            marginInline: 10,
                            objectFit: 'contain',
                            position: 'absolute',
                            bottom: -1,
                            right: 0,
                            zIndex: 9999
                        
                      }}
                src={require('./assets/pincode.png')}
                alt="Logo"
            /> 

         


            

            

            
            {showModal &&  <div onClick={()=>setShowModal(false)} style={{position: 'absolute', top: 0, bottom: 0, left: 0,width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#00000063', zIndex: 9999}}>
              <QRCode
              size={256}
              style={{ height: 400,  width: 400 }}
              value={showModal}
              divBox={`0 0 256 256`}
            />
            </div>}
           
          </div>
        </div>
      </div>
     
    );
  };

export default Index;